import React from 'react';
import APIHealthCheck from '../components/APIHealth/APIHealthCheck';

const APIHealth: React.FC = () => {
  return <APIHealthCheck />;
};

export default APIHealth; 